import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventWhistleOvertimeStartFirstHalftime extends DomainEvent<MatchEvent> {}
